import React from "react";
import PropTypes from "prop-types";
import { Error } from "@ebsco-ui/ebsco-ui";

import "./app-error.scss";

const AppError = ({ children, description, title }) => {
  return (
    <div className="app-error">
      <Error title={title} description={description}>
        {children}
      </Error>
    </div>
  );
};

AppError.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default AppError;
